import { render, staticRenderFns } from "./Edit1.vue?vue&type=template&id=01cf500e&scoped=true&"
import script from "./Edit1.vue?vue&type=script&lang=js&"
export * from "./Edit1.vue?vue&type=script&lang=js&"
import style0 from "./Edit1.vue?vue&type=style&index=0&id=01cf500e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cf500e",
  null
  
)

export default component.exports